import { useDefaultLocalizationTexts } from '@mews/framework';
import { getToken, ThemeVariant, WithChildren } from '@optimus-web/core';
import { DENSE_DARK_THEME, DENSE_LIGHT_THEME, OptimusProvider } from '@optimus-web/theme';
import { getThemeOverrides } from '../../theme/theme';

export interface ThemeWrapperProps extends WithChildren {
    primaryColor: string | null;
    variant: ThemeVariant;
}

export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children, primaryColor, variant }) => {
    const finalVariant: ThemeVariant = variant.toLowerCase() === 'dark' ? 'dark' : 'light';
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const overrides = primaryColor ? getThemeOverrides(primaryColor) : undefined;
    const localButtonOverrides =
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        primaryColor && overrides
            ? {
                  backgroundInteractivePrimaryDefault: primaryColor,
                  backgroundInteractivePrimaryActive: overrides.decisions.interactive.primary.active,
                  backgroundInteractivePrimaryHover: overrides.decisions.interactive.primary.hover,
                  borderInteractiveFocus: overrides?.decisions.borderColor.semantic.primary,
                  borderInteractivePrimaryDefault: overrides?.decisions.borderColor.semantic.primary,
                  textInteractivePrimaryDefault: overrides.decisions.interactive.primary.default,
                  borderInteractivePrimaryHover: overrides.decisions.interactive.primary.hover,
                  borderInteractivePrimaryActive: overrides.decisions.interactive.primary.active,
              }
            : undefined;

    return (
        <OptimusProvider
            tokenOverrides={{
                ...localButtonOverrides,
                backgroundStaticSunken: getToken('backgroundStaticFlat')({
                    theme: finalVariant === 'dark' ? DENSE_DARK_THEME : DENSE_LIGHT_THEME,
                }),
            }}
            themeVariant={finalVariant}
            localizationTexts={useDefaultLocalizationTexts()}
        >
            {children}
        </OptimusProvider>
    );
};
